<template>
  <div>
    <info-text :resource="resource" crud-type="edit" />
    <va-edit-layout :title="title" disable-clone>
      <users-form :id="id" :item="item" :isEdit="true" />
      <template #actions>
        <login-as-btn :item="item" />
      </template>
    </va-edit-layout>
  </div>
</template>

<script>
import InfoText from "@/components/helper/InfoText";
export default {
  components: { InfoText },
  props: ["id", "title", "item", "resource"]
};
</script>
